<template>
  <section id="login">
    <div class="container">
      <div class="row justify-content-md-center mb-2">
        <div>
          <img
            width="100%"
            src="@/assets/svg/Ardunic Account page-111.svg"
            alt="login"
          />
        </div>
      </div>
      <div v-if="!showForgetPassword" class="row justify-content-md-center">
        <div class="col col-lg-4" style="padding-right: 5px">
          <div id="login-card">
            <form @submit.prevent="NotRobotSignUp = !NotRobotSignUp">
              <div id="input">
                <input
                  type="text"
                  v-model="signup.name"
                  placeholder="User Name"
                  required
                />
              </div>
              <div id="input">
                <input
                  type="text"
                  v-model="signup.phone"
                  placeholder="Your Phone Number : 7800000000"
                  required
                  max="11"
                  min="10"
                />
              </div>
              <div id="input">
                <input
                  type="email"
                  v-model="signup.email"
                  placeholder="Email"
                  required
                />
              </div>
              <div id="input">
                <input
                  type="password"
                  v-model="signup.password"
                  placeholder="Password"
                  required
                />
              </div>

              <div id="input-b">
                <button
                  type="submit"
                  class="singup-b d-flex justify-content-center align-items-center"
                >
                  <pulse-loader
                    :loading="isLoadingRegistration"
                    :color="'#000000'"
                    :size="'15px'"
                    style="margin-right: 4px;"
                  ></pulse-loader
                  >Sign up
                </button>
              </div>
              <div v-if="NotRobotSignUp">
                <vue-recaptcha
                  ref="recaptcha"
                  @verify="onVerify"
                  @expired="expiredMethod"
                  @error="errorMethod"
                  sitekey="6LecC2sdAAAAAJmY-0NX-_5PjQYZJR1dZkWILKq6"
                  :loadRecaptchaScript="true"
                ></vue-recaptcha>
              </div>
            </form>
          </div>
          <p v-if="error2" style="color: red">{{ errorMessage2 }}</p>
        </div>
        <div class="col col-lg-4" style="padding-left: 5px">
          <div id="login-card">
            <form
              style="margin-top: 70px"
              action
              class="justify-content-md-center"
              @submit.prevent="login"
            >
              <div id="input">
                <input
                  type="text"
                  v-model="username"
                  placeholder="Your Phone Number : 7800000000"
                  required
                  max="11"
                  min="10"
                />
              </div>
              <div id="input">
                <input
                  type="password"
                  v-model="password"
                  placeholder="Password"
                  required
                />
              </div>
              <div id="input-b">
                <button
                  type="submit"
                  class="login-b d-flex justify-content-center align-items-center"
                >
                  <pulse-loader
                    :loading="isLoadingLogin"
                    :color="'#000000'"
                    :size="'15px'"
                    style="margin-right: 4px;"
                  ></pulse-loader
                  >Login
                </button>
              </div>

              <p
                class="text-center cursor-pointer"
                style="text-decoration: underline;"
                @click="toggleForgetPassword"
              >
                Forget Password
              </p>

              <p v-if="error" style="color: red">{{ errorMessage }}</p>
            </form>
          </div>
        </div>
      </div>
      <dir v-if="showForgetPassword" class="row justify-content-md-center">
        <div v-if="!secret" class="col col-lg-4" style="padding-left: 5px">
          <div id="login-card">
            <form
              style="margin-top: 70px"
              action
              class="justify-content-md-center"
              @submit.prevent="
                isSentVerificationCode
                  ? `${submitVerificationCode()}`
                  : (NotRobotForgetPassword = !NotRobotForgetPassword)
              "
            >
              <div id="input">
                <input
                  type="text"
                  v-model="username"
                  placeholder="Your Phone Number : 7800000000"
                  required
                  max="11"
                  min="10"
                  :disabled="isSentVerificationCode"
                />
              </div>
              <div v-if="isSentVerificationCode" id="input">
                <input
                  type="text"
                  v-model="code"
                  placeholder="Verification Code"
                  max="8"
                  min="8"
                  :required="isSentVerificationCode"
                />
              </div>
              <div id="input-b">
                <button
                  type="submit"
                  class="login-b d-flex justify-content-center align-items-center"
                >
                  <pulse-loader
                    :loading="isLoadingLogin"
                    :color="'#000000'"
                    :size="'15px'"
                    style="margin-right: 4px;"
                  ></pulse-loader
                  >{{ isSentVerificationCode ? "Verify" : "Send Code" }}
                </button>
                <div v-if="NotRobotForgetPassword">
                  <vue-recaptcha
                    ref="recaptcha"
                    @verify="onVerify2"
                    @expired="expiredMethod"
                    @error="errorMethod"
                    sitekey="6LecC2sdAAAAAJmY-0NX-_5PjQYZJR1dZkWILKq6"
                    :loadRecaptchaScript="true"
                  ></vue-recaptcha>
                </div>
              </div>
              <p v-if="error" style="color: red">{{ errorMessage }}</p>
            </form>
          </div>
        </div>
        <div v-if="secret" class="col col-lg-4" style="padding-left: 5px">
          <div id="login-card">
            <form
              style="margin-top: 70px"
              action
              class="justify-content-md-center"
              @submit.prevent="submitForgetPassword"
            >
              <div id="input">
                <input
                  type="password"
                  v-model="newPassword"
                  placeholder="Your New Password"
                  required
                />
              </div>
              <div id="input-b">
                <button
                  type="submit"
                  class="login-b d-flex justify-content-center align-items-center"
                >
                  <pulse-loader
                    :loading="isLoadingForgetPassword"
                    :color="'#000000'"
                    :size="'15px'"
                    style="margin-right: 4px;"
                  ></pulse-loader
                  >Reset Password
                </button>
              </div>
              <p v-if="error" style="color: red">{{ errorMessage }}</p>
            </form>
          </div>
        </div>
      </dir>
    </div>
  </section>
</template>

<script>
import VueRecaptcha from "vue-recaptcha";
import helpers from "../helpers/helpers";
export default {
  components: { VueRecaptcha },
  data() {
    return {
      error: false,
      isLoadingLogin: false,
      isLoadingRegistration: false,
      errorMessage: "",
      error2: false,
      errorMessage2: "",
      username: "",
      password: "",
      showForgetPassword: false,
      signup: {},
      isSentVerificationCode: false,
      secret: "",
      newPassword: "",
      isLoadingForgetPassword: false,
      NotRobotSignUp: false,
      NotRobotForgetPassword: false,
      reCaptchaToken: "",
    };
  },
  methods: {
    //If not robot show sign up button
    onVerify: function(response) {
      if (response) {
        this.reCaptchaToken = response;
        this.NotRobotSignUp = false;
        this.signUp();
      }
    },
    onVerify2: function(response) {
      if (response) {
        this.reCaptchaToken = response;
        this.NotRobotForgetPassword = false;
        this.submitVerificationCode();
      }
    },
    async login() {
      this.isLoadingLogin = true;
      try {
        const response = await this.$store.dispatch("login", {
          email: this.username,
          password: this.password,
        });
        helpers.notify(this.swal, {
          title: "Done",
          text: `Welecome back ${response.data.userProfile.name}`,
        });
        this.$router.push("/");
        this.isLoadingLogin = false;
      } catch (err) {
        this.isLoadingLogin = false;
      }
    },
    submitVerificationCode() {
      if (this.isSentVerificationCode) return this.activateAccount();
      return this.resendCode();
    },
    async resendCode() {
      try {
        this.isLoadingLogin = true;
        await this.$http.post("/resend_code", {
          phone: this.username,
          action: "reset_password",
          reCaptchaToken: this.reCaptchaToken,
        });
        this.isLoadingLogin = false;
        this.isSentVerificationCode = true;
      } catch (err) {
        this.isLoadingLogin = false;
      }
    },
    signUp() {
      this.isLoadingRegistration = true;
      this.$store
        .dispatch("signup", {
          name: this.signup.name,
          email: this.signup.email,
          password: this.signup.password,
          role: this.signup.role,
          phone: this.signup.phone,
          reCaptchaToken: this.reCaptchaToken,
          location: {
            lot: "",
            lat: "",
          },
        })
        .then(() => {
          this.$router.push({
            name: "activation",
            params: { phone: this.signup.phone },
          });
        })
        .catch((error) => {
          if (!error.response.data.success) {
            this.error2 = true;
            this.errorMessage2 = error.response.data.message;
          }
          this.isLoadingRegistration = false;
        });
    },
    async activateAccount() {
      try {
        this.isLoadingLogin = true;
        const {
          data: { data },
        } = await this.$http.post("/verification/reset_password", {
          phone: this.username,
          code: this.code,
          action: "reset_password",
        });
        this.secret = data.secret;
      } catch (err) {
        this.isLoadingLogin = false;
      }
    },
    async submitForgetPassword() {
      this.isLoadingForgetPassword = true;
      const {
        data: {
          data: { token },
        },
      } = await this.$http.post("/password/forget", {
        phone: this.username,
        password: this.newPassword,
        secret: this.secret,
        reCaptchaToken: this.reCaptchaToken,
      });
      this.$store.dispatch("verifyUser", { token });
      this.$router.push("/");
      this.isLoadingForgetPassword = false;
    },
    toggleForgetPassword() {
      this.showForgetPassword = !this.showForgetPassword;
    },
  },
};
</script>

<style scoped>
#login {
  margin-top: 90px;
}

#circle {
  background: linear-gradient(to right, #05cefc, #5659ce);
  border-radius: 50%;
  width: 150px;
  height: 150px;
  border: none;
  display: flex;
  justify-content: center;
  align-items: center;
}

::placeholder {
  color: #2a2a2a;
}

#login-card {
  border: 1px solid #2a2a2a;
  width: 100%;
  height: 320px;
  border-radius: 20px;
  text-align: center;
}

#input {
  border: 1px solid #2a2a2a;
  margin: 10px 0px;
  border-radius: 20px;
  height: 40px;
  color: #2a2a2a;
}

#input-b {
  border: none;
  margin: 10px 0px;
  border-radius: 20px;
  height: 40px;
}
#input-b .login-b {
  border: none;
  width: 100%;
  height: 100%;
  border-radius: 20px;
  background: linear-gradient(to right, #46ad68, #05f040);
  color: white;
  border: none;
}
form {
  margin-top: 20px;
  margin-left: 15px;
  margin-right: 15px;
}

#input input {
  border: none;
  text-align: center;
  height: 100%;
}

#input-b button {
  border: none;
  width: 100%;
  height: 100%;
  border-radius: 20px;
  background: linear-gradient(to right, #05cefc, #5659ce);
  color: white;
  border: none;
}
</style>
